(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8723],{

/***/ 6285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/Afbeelding1.dd5b9dd9.jpg","height":417,"width":990,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAaEAEAAwADAAAAAAAAAAAAAAACAAERAyFR/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgX/xAAXEQEAAwAAAAAAAAAAAAAAAAABAAIh/9oADAMBAAIRAxEAPwCi4gKSJyzmX53ERI9lXYLqOT//2Q==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 86262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/cet_g.409a5ce3.svg","height":445,"width":721});

/***/ }),

/***/ 27736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/news1.fe9b4c13.png","height":358,"width":570,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAQlBMVEWurq7Jycn////i4uLo6Ojs7OzX19fHx8f///+8vLzn5+f+/v7y8vLIyMimpqajo6Pr6+vw8PC9vb3l5eX///+/v7+Lq5ROAAAAE3RSTlP9/Orhio/+5tzmd8X50/7+7X/0n1CqMQAAAAlwSFlzAAALEwAACxMBAJqcGAAAADFJREFUeJwFwQESgCAIAMGzQCArdaD/f7VdnjCL8xgYk6+XEy+0u5yVmT3L2SqqItcPII0BfwB/GUYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 95620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Form; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87536);



/**
 * Returns a form with the given props, and includes 'react-hook-form' functionality.
 * @param {FormProps}  - FormProps
 * @returns A form component that takes in a defaultValues object, children, onSubmit function, and a
 * className string.
 */ function Form(param) {
    let { defaultValues , children , onSubmit , onInvalid , className , id  } = param;
    const { reset , handleSubmit , register , setError , formState: { errors  }  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useForm */ .cI)({
        defaultValues
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // you can do async server request and fill up form
        reset({
            ...defaultValues
        });
    }, [
        defaultValues,
        reset
    ]);
    function injectFormProps(node) {
        var ref, ref1;
        if (!/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.isValidElement(node)) {
            return node;
        }
        const childProps = {};
        if ((ref = node.props) === null || ref === void 0 ? void 0 : ref.name) {
            childProps.register = register;
            childProps.errors = errors;
            childProps.key = node.props.name;
        }
        if ((ref1 = node.props) === null || ref1 === void 0 ? void 0 : ref1.children) {
            childProps.children = react__WEBPACK_IMPORTED_MODULE_1__.Children.map(node.props.children, injectFormProps);
        }
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(node, childProps);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
        onSubmit: handleSubmit((values, event)=>onSubmit(values, event, {
                setError
            }), onInvalid),
        className: className,
        id: id,
        children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, injectFormProps)
    });
}


/***/ }),

/***/ 27778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1954);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var primereact_calendar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68751);
/* harmony import */ var primereact_chips__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97506);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _Input_module_sass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19227);
/* harmony import */ var _Input_module_sass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Input_module_sass__WEBPACK_IMPORTED_MODULE_6__);







function Input(param) {
    let { title , titleClass , inputClass , divClass , type ="text" , register , icon , name , value , onChange , rules ={} , errors , rows , placeholder , disabled , gradient , ...rest } = param;
    const [isPasswordVisible, setIsPasswordVisible] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const togglePasswordVisibility = ()=>{
        setIsPasswordVisible((prev)=>!prev);
    };
    function errorGenerator(errorObj) {
        switch(errorObj === null || errorObj === void 0 ? void 0 : errorObj.type){
            case "required":
                return (errorObj === null || errorObj === void 0 ? void 0 : errorObj.message) || "Dit veld is verplicht";
            case "minLength":
                return "Dit veld moet minimaal ".concat(errorObj.message, " tekens bevatten");
            case "maxLength":
                return "Dit veld mag maximaal ".concat(errorObj.message, " tekens bevatten");
            case "min":
                return "Dit veld moet minimaal ".concat(errorObj.message, " zijn");
            case "max":
                return "Dit veld mag maximaal ".concat(errorObj.message, " zijn");
            case "pattern":
                return errorObj.message;
            case "validate":
                return (errorObj === null || errorObj === void 0 ? void 0 : errorObj.message) || "Dit veld is niet geldig";
            default:
                return null;
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_Input_module_sass__WEBPACK_IMPORTED_MODULE_6___default().input), " ").concat(divClass),
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("".concat((_Input_module_sass__WEBPACK_IMPORTED_MODULE_6___default().input__title), " ").concat(titleClass && titleClass), (errors === null || errors === void 0 ? void 0 : errors[name]) && "!border-rose-600"),
                children: [
                    title,
                    (rules === null || rules === void 0 ? void 0 : rules.required) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_Input_module_sass__WEBPACK_IMPORTED_MODULE_6___default().required),
                        children: " *"
                    })
                ]
            }),
            type !== "chips" && type !== "textarea" && type !== "date" && type !== "password" && type !== "inputname" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: type,
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Input_module_sass__WEBPACK_IMPORTED_MODULE_6___default().input__element), "input_component", inputClass, (errors === null || errors === void 0 ? void 0 : errors[name]) && "!border-rose-600 focus:!border-primary"),
                name: name,
                onChange: onChange,
                placeholder: placeholder,
                disabled: disabled,
                icon: icon,
                ...register === null || register === void 0 ? void 0 : register(name, rules),
                ...rest
            }),
            type === "inputname" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                type: type,
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Input_module_sass__WEBPACK_IMPORTED_MODULE_6___default().input__element), "input_component", inputClass, (errors === null || errors === void 0 ? void 0 : errors[name]) && "!border-rose-600 focus:!border-primary"),
                name: name,
                onChange: onChange,
                placeholder: placeholder,
                disabled: disabled,
                icon: icon,
                value: value,
                ...register === null || register === void 0 ? void 0 : register(name, rules),
                ...rest
            }),
            type === "password" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat((_Input_module_sass__WEBPACK_IMPORTED_MODULE_6___default().passwordToggle)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: isPasswordVisible ? "text" : "password",
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Input_module_sass__WEBPACK_IMPORTED_MODULE_6___default().input__element), "input_component", inputClass, (errors === null || errors === void 0 ? void 0 : errors[name]) && "!border-rose-600 focus:!border-primary"),
                        name: name,
                        onChange: onChange,
                        placeholder: placeholder,
                        disabled: disabled,
                        ...register === null || register === void 0 ? void 0 : register(name, rules),
                        ...rest
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: "absolute top-1/2 right-2 transform -translate-y-1/2 cursor-pointer",
                        onClick: togglePasswordVisibility,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
                            icon: isPasswordVisible ? "fa6-regular:eye" : "gravity-ui:eye-slash",
                            className: "text-[#999999]"
                        })
                    })
                ]
            }),
            type === "textarea" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                className: "".concat((_Input_module_sass__WEBPACK_IMPORTED_MODULE_6___default().input__element), " ").concat(inputClass && inputClass),
                name: name,
                onChange: onChange,
                rows: rows,
                disabled: disabled,
                ...register === null || register === void 0 ? void 0 : register(name, rules),
                ...rest
            }),
            type === "chips" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(primereact_chips__WEBPACK_IMPORTED_MODULE_4__/* .Chips */ .c, {
                name: name + "x",
                value: value,
                onChange: onChange,
                separator: ",",
                allowDuplicate: false,
                addOnBlur: true,
                autoComplete: "new-keywords",
                disabled: disabled
            }),
            type === "date" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(primereact_calendar__WEBPACK_IMPORTED_MODULE_3__/* .Calendar */ .f, {
                name: name,
                value: value,
                onChange: onChange,
                dateFormat: "dd-mm-yy",
                showIcon: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_Input_module_sass__WEBPACK_IMPORTED_MODULE_6___default().error),
                children: errorGenerator(errors === null || errors === void 0 ? void 0 : errors[name])
            })
        ]
    });
}


/***/ }),

/***/ 98694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ newButtonClassName; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function getColorClass(color, disabled) {
    if (disabled) {
        return "bg-zinc-500 disabled:bg-zinc-500";
    }
    switch(color){
        case "orange":
            return "bg-primary-orange";
        default:
            return "bg-primary";
    }
}
// Also used to style a link as a NewButton, so a link never wraps a button.
function newButtonClassName(color, className, disabled) {
    return classnames__WEBPACK_IMPORTED_MODULE_1___default()(getColorClass(color, disabled), "rounded-[8px] px-16 py-2 font-semibold text-zinc-50 transition hover:scale-105 shadow-button disabled:!cursor-not-allowed disabled:!scale-100 active:scale-95", className);
}
function NewButton(param) {
    let { children , color , className , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: newButtonClassName(color, className, rest.disabled),
        ...rest,
        children: children
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (NewButton);


/***/ }),

/***/ 67291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ NewLanding_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@iconify/react/dist/iconify.mjs
var iconify = __webpack_require__(1954);
;// CONCATENATED MODULE: ./assets/logo/cet_w.svg
/* harmony default export */ var cet_w = ({"src":"/_next/static/media/cet_w.35df18fb.svg","height":445,"width":721});
// EXTERNAL MODULE: ./node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(27856);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/cookieConsent.ts
var cookieConsent = __webpack_require__(46435);
;// CONCATENATED MODULE: ./components/NewLanding/Footer.tsx







function Footer() {
    const FOOTER_LINKS = [
        {
            title: "Homepagina",
            links: [
                {
                    title: "Home",
                    href: "/"
                },
                // {
                //   title: 'Componenten',
                //   href: '/componenten'
                // },
                // {
                //   title: 'Functies',
                //   href: '/functies'
                // },
                {
                    title: "Demo",
                    href: "/#demo"
                },
                {
                    title: "FAQ",
                    href: "/faq"
                }
            ]
        },
        {
            title: "Links",
            links: [
                {
                    title: "Contact",
                    href: "/"
                },
                {
                    title: "Privacy reglement",
                    href: "/privacy-reglement"
                },
                {
                    title: "Login",
                    href: "/user/login"
                }
            ]
        }
    ];
    const EMAIL = "info@cetrainer.nl".replace(/[a-zA-Z]/g, (char)=>"&#".concat(char.charCodeAt(0), ";"));
    const year = new Date().getFullYear();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "bg-primary-800 py-[40px] px-[20px] sm:py-[50px] sm:px-[40px] lg:py-[60px] lg:px-[100px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-wrap justify-between gap-8 sm:gap-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center justify-center sm:items-start sm:justify-normal gap-5 mx-auto sm:mx-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[190px] sm:w-[100px] lg:w-[130px] xl:w-[170px] flex justify-center items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: cet_w,
                                alt: "CET Logo",
                                width: 200,
                                height: 120,
                                className: "w-[190px] sm:w-[100px] lg:w-[130px] xl:w-[170px] h-auto"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col justify-center items-start gap-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center text-white",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                            icon: "line-md:map-marker-filled",
                                            className: "text-2xl mr-2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-semibold",
                                            children: "Adres:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ml-2",
                                            children: "Amsterdam, Nederland"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center text-white hover:cursor-pointer",
                                    onClick: ()=>window.location.href = "mailto:info@cetrainer.nl",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                            icon: "weui:email-filled",
                                            className: "text-2xl mr-2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-semibold",
                                            children: "E-mail:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ml-3",
                                            dangerouslySetInnerHTML: {
                                                __html: (0,purify.sanitize)(EMAIL)
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col justify-start sm:items-start sm:justify-center gap-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "flex flex-col justify-center items-start gap-5 sm:gap-4 xl:gap-6",
                            children: FOOTER_LINKS[0].links.map((link, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: link.href,
                                        className: "text-white",
                                        children: link.title
                                    })
                                }, index))
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col justify-start sm:items-start sm:justify-center gap-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "flex flex-col justify-center items-start gap-5 sm:gap-4 xl:gap-6",
                            children: [
                                FOOTER_LINKS[1].links.map((link, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: link.href,
                                            className: "text-white",
                                            children: link.title
                                        })
                                    }, index)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        onClick: cookieConsent/* openCookieSettings */.Vh,
                                        className: "text-white",
                                        children: "Cookie-instellingen"
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var NewLanding_Footer = (Footer);


/***/ }),

/***/ 24432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ NewLanding_Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./assets/icons/Cross.svg
/* harmony default export */ var Cross = ({"src":"/_next/static/media/Cross.6d09545f.svg","height":28,"width":28});
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(48680);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(71921);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/CustomLink.tsx




function CustomLink(param) {
    let { href , children , className  } = param;
    const { pathname  } = (0,next_router.useRouter)();
    const isActive = href === pathname;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        className: "".concat(isActive ? "text-[#079992] border-b-2 border-[#079992]" : "text-[#666666] relative border-b-2 border-transparent after:-bottom-0 after:absolute after:left-0 after:right-0 after:scale-0 after:origin-center after:hover:scale-100 after:h-[2px] after:bg-zinc-900 after:transition after:duration-200", " font-semibold py-[8px] ").concat(className),
        children: children
    });
}
/* harmony default export */ var components_CustomLink = (CustomLink);

// EXTERNAL MODULE: ./components/NewButton.tsx
var NewButton = __webpack_require__(98694);
// EXTERNAL MODULE: ./node_modules/hamburger-react/dist-esm/index.js + 2 modules
var dist_esm = __webpack_require__(17218);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/NewLanding/Header.tsx











function Header() {
    const router = (0,next_router.useRouter)();
    const [isMenuOpen, setIsMenuOpen] = (0,react.useState)(false);
    const isActive = (href)=>router.pathname === href;
    function scrollToComponents() {
        (0,helpers/* scrollWithOffset */.eU)("components", 60);
    }
    function scrollToDemo() {
        (0,helpers/* scrollWithOffset */.eU)("demo", 60);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "fixed z-20 w-full flex justify-between items-center bg-white px-[20px] lg:px-[100px] py-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: __webpack_require__(86262),
                                alt: "CET Logo",
                                height: 60,
                                width: 97,
                                className: "w-[97.21px] h-[60px] hover:scale-110 transition duration-200",
                                priority: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden lg:flex items-center gap-10",
                        children: constants/* HeaderLinks.map */.f4.map((link, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomLink, {
                                href: link.link,
                                children: link.title
                            }, index))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* default */.ZP, {
                            direction: "right",
                            size: 30,
                            color: "#079992",
                            toggled: isMenuOpen,
                            toggle: setIsMenuOpen
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden lg:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/user/login",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewButton/* default */.Z, {
                                color: "orange",
                                className: "uppercase px-12 py-[14px] rounded-lg text-base font-semibold",
                                children: "Login"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "fixed inset-0 z-20 bg-white transition-transform duration-200 ".concat(isMenuOpen ? "translate-y-0" : "-translate-y-full", " shadow-lg"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center p-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                onClick: ()=>setIsMenuOpen(false),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: __webpack_require__(86262),
                                    alt: "CET Logo",
                                    height: 60,
                                    width: 97,
                                    className: "w-[97.21px] h-[60px]"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: ()=>setIsMenuOpen(false),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: Cross,
                                    alt: "Cross Icon",
                                    height: 28,
                                    width: 28,
                                    className: "w-[28px] h-[28px]"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex flex-col gap-[10px] text-center",
                        children: constants/* HeaderLinks.map */.f4.map((link, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: link.link,
                                className: "".concat(isActive(link.link) ? "bg-primary text-white" : "text-[#666666]", " w-full font-semibold py-[14px] hover:bg-primary hover:text-white"),
                                onClick: ()=>setIsMenuOpen(false),
                                children: link.title
                            }, index))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full px-10 mt-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/user/login",
                            onClick: ()=>setIsMenuOpen(false),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewButton/* default */.Z, {
                                color: "orange",
                                className: "uppercase w-full py-[14px] text-center rounded-lg font-semibold",
                                children: "Login"
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var NewLanding_Header = (Header);


/***/ }),

/***/ 45103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_ContactButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@iconify/react/dist/iconify.mjs
var iconify = __webpack_require__(1954);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(34518);
// EXTERNAL MODULE: ./components/Form/Form.tsx
var Form = __webpack_require__(95620);
// EXTERNAL MODULE: ./components/Form/Input.tsx
var Input = __webpack_require__(27778);
// EXTERNAL MODULE: ./hooks/useToast.ts + 1 modules
var useToast = __webpack_require__(97673);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/primereact/dialog/dialog.esm.js
var dialog_esm = __webpack_require__(63861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(48680);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(71921);
;// CONCATENATED MODULE: ./assets/icons/contact.svg
/* harmony default export */ var contact = ({"src":"/_next/static/media/contact.ed7c2b28.svg","height":40,"width":40});
// EXTERNAL MODULE: ./components/UI/ContactButton/ContactButton.module.sass
var ContactButton_module = __webpack_require__(40500);
var ContactButton_module_default = /*#__PURE__*/__webpack_require__.n(ContactButton_module);
;// CONCATENATED MODULE: ./components/UI/ContactButton/index.tsx















function ContactButton(param) {
    let {} = param;
    const dialogOptions = [
        {
            label: "Indienen belverzoek",
            icon: "ph:phone-call",
            callback: ()=>setDialogScreen("CALL")
        },
        {
            label: "Vul contactformulier in",
            icon: "material-symbols:contact-mail-outline",
            callback: ()=>setDialogScreen("FORM")
        },
        {
            label: "Email ons",
            icon: "ph:envelope-simple",
            link: "mailto:info@cetrainer.nl?Subject=Bericht van CETrainer.nl"
        }
    ];
    const { toast  } = (0,useToast/* useToast */.p)();
    const [scrollPos, setScrollPos] = (0,react.useState)(window.scrollY);
    const [dialogVisible, setDialogVisible] = (0,react.useState)(false);
    const [dialogScreen, setDialogScreen] = (0,react.useState)("INITIAL");
    (0,react.useEffect)(()=>{
        if (dialogVisible) setDialogScreen("INITIAL");
    }, [
        dialogVisible
    ]);
    function handleScroll() {
        setScrollPos(window.scrollY);
    }
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    async function handleContactSubmit(data) {
        const url = "https://formspree.io/f/mzbogpor";
        try {
            var // TODO: Translate
            ref;
            await axios/* default.post */.Z.post(url, {
                ...data,
                email: data.email.trim(),
                name: data.name.trim(),
                organization: data.organization.trim(),
                description: data.description.trim()
            });
            setDialogVisible(false);
            (ref = toast.current) === null || ref === void 0 ? void 0 : ref.show({
                severity: "success",
                summary: "Message sent",
                detail: "We will get back to you as soon as possible",
                life: 3000
            });
        } catch (e) {
            (0,helpers/* printError */.OS)(e);
        }
    }
    async function handleCallSubmit(data) {
        const url = "https://formspree.io/f/myyojgoe";
        try {
            var // TODO: Translate
            ref;
            await axios/* default.post */.Z.post(url, {
                ...data,
                name: data.name.trim(),
                phone: data.phone.trim(),
                description: data.description.trim(),
                time: data.time.trim()
            });
            setDialogVisible(false);
            (ref = toast.current) === null || ref === void 0 ? void 0 : ref.show({
                severity: "success",
                summary: "Call request sent",
                detail: "We will get back to you as soon as possible",
                life: 3000
            });
        } catch (e) {
            (0,helpers/* printError */.OS)(e);
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog_esm/* Dialog */.V, {
                header: "Neem contact op met CETrainer",
                visible: dialogVisible,
                onHide: ()=>setDialogVisible(false),
                className: (ContactButton_module_default()).dialog__wrapper,
                ...constants/* MODAL_ATTRIBUTES */.H2,
                children: [
                    dialogScreen === "INITIAL" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ContactButton_module_default()).dialog,
                        children: dialogOptions.map((ele, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ContactButton_module_default()).dialog__option,
                                children: ele.link ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: ele.link,
                                    className: (ContactButton_module_default()).dialog__link,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                            icon: ele.icon,
                                            className: (ContactButton_module_default()).dialog__icon
                                        }),
                                        ele.label
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: ele.callback,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (ContactButton_module_default()).dialog__option__label,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                                icon: ele.icon,
                                                className: (ContactButton_module_default()).dialog__icon
                                            }),
                                            ele.label,
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                                icon: "ph:arrow-right",
                                                style: {
                                                    marginLeft: "auto"
                                                }
                                            })
                                        ]
                                    })
                                })
                            }, i))
                    }),
                    dialogScreen === "FORM" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
                        onSubmit: handleContactSubmit,
                        className: (ContactButton_module_default()).form__contact,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                title: "Naam",
                                name: "name",
                                rules: {
                                    required: true
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                title: "Email",
                                name: "email",
                                rules: {
                                    required: true,
                                    pattern: constants/* RULES.EMAIL.pattern */.VC.EMAIL.pattern
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                title: "Organisatie",
                                name: "organization"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                title: "Toelichting",
                                name: "description",
                                rules: {
                                    required: true
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ContactButton_module_default()).form__contact__buttons,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                        onClick: ()=>setDialogScreen("INITIAL"),
                                        bgType: "orange",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                                icon: "ph:arrow-left"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Terug"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                        type: "submit",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                                icon: "ph:paper-plane"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Stuur formulier op"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    dialogScreen === "CALL" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
                        onSubmit: handleCallSubmit,
                        className: (ContactButton_module_default()).form__call,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                title: "Naam",
                                name: "name",
                                rules: {
                                    required: true
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                title: "Telefoonnummer",
                                name: "phone",
                                rules: {
                                    required: true
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                title: "Korte toelichting",
                                name: "description",
                                rules: {
                                    required: true
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                title: "Geschikt tijdstip",
                                name: "time"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ContactButton_module_default()).form__contact__buttons,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                        onClick: ()=>setDialogScreen("INITIAL"),
                                        bgType: "orange",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                                icon: "ph:arrow-left"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Terug"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                        type: "submit",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                                icon: "ph:paper-plane"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Dien je belverzoek in"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "fixed bottom-[-8rem] right-[2rem] rounded-[100px] z-[49] transition-all duration-300 ease-in w-[60px] h-[60px] lg:w-[80px] lg:h-[80px] ".concat(scrollPos > 20 && "bottom-[2rem]"),
                onClick: ()=>setDialogVisible(true),
                bgType: "orange",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: contact,
                    alt: "contact",
                    width: 40,
                    height: 40,
                    className: "w-[30px] h-[30px] lg:w-[40px] lg:h-[40px]"
                })
            })
        ]
    });
}
/* harmony default export */ var UI_ContactButton = (ContactButton);


/***/ }),

/***/ 48680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ DRAWING_TOOL_DISABLED_SUBJECTS; },
/* harmony export */   "Am": function() { return /* binding */ SECTION_TEXT_AUTO_FILL_ENABLED; },
/* harmony export */   "Ct": function() { return /* binding */ SUBJECT_ICONS; },
/* harmony export */   "EM": function() { return /* binding */ CMS_COMMENT_TEST_AUTHORS; },
/* harmony export */   "FJ": function() { return /* binding */ EXAM_PDF_PANEL_MIN_WIDTH; },
/* harmony export */   "G8": function() { return /* binding */ subjectsByLevel; },
/* harmony export */   "H2": function() { return /* binding */ MODAL_ATTRIBUTES; },
/* harmony export */   "HK": function() { return /* binding */ FACET_SOURCE_SPLIT_MIN_CHARS; },
/* harmony export */   "IV": function() { return /* binding */ STATISTICS_DATA; },
/* harmony export */   "J": function() { return /* binding */ SECTION_EDITOR_LAYOUT_KEY; },
/* harmony export */   "Kk": function() { return /* binding */ FEEDBACK_FLAG_KEY; },
/* harmony export */   "LJ": function() { return /* binding */ subjectsDictionary; },
/* harmony export */   "Nq": function() { return /* binding */ REVIEW_MIN_EXTRACTOR_VERSION; },
/* harmony export */   "PX": function() { return /* binding */ CMS_COMMENT_OPEN_COUNTS_KEY; },
/* harmony export */   "Q_": function() { return /* binding */ FACET_SOURCE_SPLIT_KEY; },
/* harmony export */   "Qc": function() { return /* binding */ sectionData; },
/* harmony export */   "Qs": function() { return /* binding */ EXAM_PDF_PANEL_RATIO_KEY; },
/* harmony export */   "SW": function() { return /* binding */ EXAM_EDITOR_MIN_WIDTH; },
/* harmony export */   "T8": function() { return /* binding */ EXAM_EDITOR_RAIL_ROOM_WIDTH; },
/* harmony export */   "TP": function() { return /* binding */ DEFAULT; },
/* harmony export */   "Ts": function() { return /* binding */ EnrollmentSteps; },
/* harmony export */   "UH": function() { return /* binding */ EXAM_PDF_PANEL_ID; },
/* harmony export */   "Ut": function() { return /* binding */ CMS_COMMENT_MAX_LENGTH; },
/* harmony export */   "VC": function() { return /* binding */ RULES; },
/* harmony export */   "Vg": function() { return /* binding */ SECTION_FORM_ID; },
/* harmony export */   "Yw": function() { return /* binding */ COPY_USED_IN_RETRIES; },
/* harmony export */   "_k": function() { return /* binding */ SECTION_EDITOR_SPLIT_MIN_WIDTH; },
/* harmony export */   "f4": function() { return /* binding */ HeaderLinks; },
/* harmony export */   "gC": function() { return /* binding */ QUOTES; },
/* harmony export */   "gr": function() { return /* binding */ levels; },
/* harmony export */   "i2": function() { return /* binding */ FACET_BOOKMARK_ENABLED; },
/* harmony export */   "iE": function() { return /* binding */ CMS_COMMENT_TEST_PREFIX; },
/* harmony export */   "ki": function() { return /* binding */ SUBJECTS; },
/* harmony export */   "lp": function() { return /* binding */ EXAM_PDF_PANEL_MAX_RATIO; },
/* harmony export */   "nT": function() { return /* binding */ EXAM_PDF_PANEL_DEFAULT_RATIO; },
/* harmony export */   "oW": function() { return /* binding */ FEEDBACK_TELEMETRY_EVENTS; },
/* harmony export */   "q$": function() { return /* binding */ CMS_COMMENTS_COLLECTION; },
/* harmony export */   "rr": function() { return /* binding */ FEEDBACK_TRIGGER_SOURCES; },
/* harmony export */   "sH": function() { return /* binding */ CMS_COMMENTS_DRAWER_ID; },
/* harmony export */   "sW": function() { return /* binding */ SECTION_EDITOR_SPLIT_MIN_EDITOR_WIDTH; },
/* harmony export */   "sX": function() { return /* binding */ FEEDBACK_AUDIENCES; },
/* harmony export */   "uD": function() { return /* binding */ SECTION_EDITOR_LAYOUTS; },
/* harmony export */   "vm": function() { return /* binding */ EXAM_PDF_PANEL_GAP; },
/* harmony export */   "vr": function() { return /* binding */ EXAM_PDF_PANEL_DOCK_QUERY; },
/* harmony export */   "yb": function() { return /* binding */ EXAM_PDF_PANEL_KEY_PREFIX; },
/* harmony export */   "zq": function() { return /* binding */ LEVELS; }
/* harmony export */ });
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35944);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54980);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31222);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19858);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18910);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40671);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1757);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13761);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46386);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69338);

const DEFAULT = {
    PHOTO_URL: "https://firebasestorage.googleapis.com/v0/b/cetrainer-95f5e.appspot.com/o/ProfilePictures%2FxQwPXksQwzOfKq87C9MD03jldoG3%2Fprofilepicture.png?alt=media&token=05f5ea9b-d701-4aa0-aca4-d65a103f4bd4",
    DISPLAY_NAME: "Unnamed"
};
const RULES = {
    EMAIL: {
        required: true,
        pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "Dit veld moet een geldig e-mailadres bevatten"
        }
    },
    PASSWORD: {
        required: true,
        minLength: {
            value: 6,
            message: "6"
        },
        maxLength: {
            value: 20,
            message: "20"
        }
    }
};
const subjectsDictionary = {
    VWO: [
        "Wiskunde A",
        "Wiskunde B",
        "Wiskunde C",
        "Natuurkunde",
        "Scheikunde",
        "Geschiedenis",
        "Engels"
    ],
    HAVO: [
        "Wiskunde A",
        "Wiskunde B",
        "Natuurkunde",
        "Scheikunde",
        "Geschiedenis",
        "Engels"
    ],
    "VMBO-TL-GL": [
        "Wiskunde",
        "Biologie",
        "Economie",
        "Nask 1",
        "Nask 2",
        "Geschiedenis",
        "Engels"
    ],
    "VMBO-KB": [
        "Wiskunde",
        "Nask 1",
        "Economie",
        "Biologie",
        "Geschiedenis",
        "Engels"
    ],
    "VMBO-BB": [
        "Wiskunde",
        "Nask 1",
        "Economie",
        "Biologie",
        "Geschiedenis",
        "Engels"
    ]
};
const EnrollmentSteps = [
    {
        label: "Welkom"
    },
    {
        label: "Gegevens"
    },
    {
        label: "Intro"
    },
    {
        label: "App Tour"
    },
    {
        label: "Starten"
    }
];
const MODAL_ATTRIBUTES = {
    dismissableMask: true,
    modal: true,
    draggable: false,
    blockScroll: true
};
/** Facet player: bookmark tool and strip dot (spec O1). */ const FACET_BOOKMARK_ENABLED = true;
/**
 * Facet player: a source longer than this many characters of HTML gets the
 * draggable divider between source and question (P0-7). The split is
 * remembered per browser under FACET_SOURCE_SPLIT_KEY (hooks/useSourceSplit).
 */ const FACET_SOURCE_SPLIT_MIN_CHARS = 1500;
const FACET_SOURCE_SPLIT_KEY = "facetSourceSplit";
/** The CMS section editor's one form (Cmd/Ctrl+S and the Name field find it). */ const SECTION_FORM_ID = "edit-section-form";
const QUOTES = [
    "Een goede leraar moet zowel inspireren als irriteren",
    "Haal even diep adem en lach",
    "Natuurlijk praat ik tegen mezelf. Soms heb ik advies van een expert nodig",
    "Als je in het dal blijft zie je nooit de andere kant van de berg",
    "Wacht niet op een goede dag, maak er \xe9\xe9n",
    "Moeilijk betekent niet onmogelijk. Het betekent dat je hard moet werken",
    "Oordeel niet over anderen als je hun last nooit gedragen hebt",
    "Met beide voeten op de grond kom je geen stap vooruit",
    "Als je goed kijkt kijkt, kun je iedere dag iets moois zien",
    "Niets was mogelijk, todat iemand het deed..",
    "Ik heb geen inspirerende quote nodig, geef mij maar koffie",
    "De stilte der natuur heeft veel geluiden",
    "Het leven is net als fietsen, om balans te houden moet je door fietsen. ",
    "Streef naar vooruitgang en niet perfectie",
    "Iedere expert is ooit een beginner geweest",
    "Educatie is de sterkste wapen om de wereld positief te veranderen",
    "Iedere student kan leren, alleen niet op dezelfde dag of dezelfde manier",
    "Als een plan niet werkt, verander dan je plan maar nooit je doel.",
    "Het mooie aan leren is dat het iets is dat niemand je kan ontnemen",
    "Het leven van een kind is net als een stuk papier waarop iedereen een afdruk achterlaat",
    "Alles wat je hoort vergeet je, alles wat je ziet onthoud je en alles wat je doet begrijp je!",
    "Je wordt nooit echt volwasssen, je leert alleen hoe je je volwassen dient te gedragen",
    "Er is geen lift naar succes, pak de trap",
    "Als je nooit een fout gemaakt hebt dan heb je nooit iets nieuws geprobeerd",
    "Als mensen nooit stomme zaken uitgeprobeerd hebben dan zou er nooit iets intelligents zijn ontstaan",
    "Alles wat we leren met plezier vergeten we nooit",
    "CETrainer is in het leven geroepen om je leven nog zuurder te maken",
    "Wat kwam er nou eigenlijk eerder? De kip of het ei?",
    "Geef iemand een vis en je hebt diegene gevoerd voor een dag, leer een persoon om te vissen en je voedt deze persoon voor het hele leven ",
    "Zou een rups ooit weten dat hij ooit een vlinder zou worden?",
    "In leraar zit niet voor niets het woord raar",
    "Docenten noemen het spieken, wij noemen het teamwork",
    "Doet mijn laptop het eindelijk, crashen mijn hersens",
    "Spring altijd in het diepe. Het ondiepe doet namelijk zeer",
    "Wat heeft de school eigenlijk van mij geleerd?",
    "Je moet de waarheid niet verwarren met de mening van de meerderheid",
    "Wees jezelf, er zijn al zoveel anderen",
    "Nooit te oud om te leren waarom dan zo vroeg beginnen?",
    "De scholen zijn weer begonnen nou jij nog",
    "Soms krijg ik meer errors dan mijn rekenmachine",
    "Het examen doet me soms denken aan het kapsel van mijn buurvrouw. Kort en pittig",
    "Mijn gemiddelde is met de valversnelling van de zon naar beneden gedonderd"
];
const LEVELS = [
    "HAVO",
    "VWO",
    "VMBO-TL-GL",
    "VMBO-KB",
    "VMBO-BB"
];
const SUBJECT_ICONS = {
    Atom: lucide_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    Calculator: lucide_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    BarChart3: lucide_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
    TrendingUp: lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
    Wallet: lucide_react__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
    Dna: lucide_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
    Book: lucide_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
    BookOpen: lucide_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
    Microscope: lucide_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
    TestTube: lucide_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z
};
const SUBJECTS = {
    Natuurkunde: {
        icon: "Atom",
        tips: {
            HAVO: "https://player.vimeo.com/video/918670421",
            VWO: "https://player.vimeo.com/video/918670439"
        }
    },
    Scheikunde: {
        icon: "TestTube",
        tips: {
            HAVO: "https://player.vimeo.com/video/919934688",
            VWO: "https://player.vimeo.com/video/919934607"
        }
    },
    "Wiskunde A": {
        icon: "BarChart3",
        tips: {
            HAVO: "https://player.vimeo.com/video/825049001",
            VWO: "https://player.vimeo.com/video/1161222597"
        }
    },
    "Wiskunde B": {
        icon: "TrendingUp",
        tips: {
            HAVO: "https://player.vimeo.com/video/825054725",
            VWO: "https://player.vimeo.com/video/825054743"
        }
    },
    "Wiskunde C": {
        icon: "BarChart3"
    },
    Wiskunde: {
        icon: "Calculator",
        tips: {
            "VMBO-TL-GL": "https://player.vimeo.com/video/918670289",
            "VMBO-KB": "https://player.vimeo.com/video/918670269",
            "VMBO-BB": "https://player.vimeo.com/video/918670239"
        }
    },
    Economie: {
        icon: "Wallet"
    },
    Biologie: {
        icon: "Dna"
    },
    Nederlands: {
        icon: "Book"
    },
    Engels: {
        icon: "BookOpen",
        tips: {
            "VMBO-TL-GL": "https://player.vimeo.com/video/1067362223",
            "VMBO-KB": "https://player.vimeo.com/video/1067362223",
            "VMBO-BB": "https://player.vimeo.com/video/1067362223"
        }
    },
    "Nask 1": {
        icon: "Microscope",
        tips: {
            "VMBO-TL-GL": "https://player.vimeo.com/video/918670192",
            "VMBO-KB": "https://player.vimeo.com/video/918670228",
            "VMBO-BB": "https://player.vimeo.com/video/918670215"
        }
    },
    "Nask 2": {
        icon: "Atom",
        tips: {
            "VMBO-TL-GL": "https://player.vimeo.com/video/919934661"
        }
    },
    Geschiedenis: {
        icon: "Book"
    }
};
const STATISTICS_DATA = [
    {
        icon: "ion:school",
        title: "Aantal leerlingen",
        value: 5800
    },
    {
        icon: "bxs:school",
        title: "Aantal scholen",
        value: 54
    },
    {
        icon: "tabler:star-filled",
        title: "Beoordeling",
        value: "4.0"
    }
];
const subjectsByLevel = {
    HAVO: [
        "Natuurkunde",
        "Scheikunde",
        "Wiskunde A",
        "Wiskunde B",
        "Biologie",
        "Geschiedenis"
    ],
    VWO: [
        "Natuurkunde",
        "Scheikunde",
        "Wiskunde A",
        "Wiskunde B",
        "Wiskunde C",
        "Biologie",
        "Geschiedenis"
    ],
    "VMBO-TL-GL": [
        "Wiskunde",
        "Engels",
        "Nederlands",
        "Nask 1",
        "Nask 2",
        "Biologie",
        "Economie",
        "Geschiedenis"
    ],
    "VMBO-KB": [
        "Wiskunde",
        "Engels",
        "Nederlands",
        "Nask 1",
        "Biologie",
        "Economie",
        "Geschiedenis"
    ],
    "VMBO-BB": [
        "Wiskunde",
        "Engels",
        "Nederlands",
        "Nask 1",
        "Biologie",
        "Economie",
        "Geschiedenis"
    ]
};
// Subjects (Firestore subject ids, as in the exam URL) whose exam view hides
// the drawing tool (Tekenen) on bijlagen.
const DRAWING_TOOL_DISABLED_SUBJECTS = [
    "Geschiedenis",
    "Aardrijkskunde"
];
const levels = [
    {
        name: "HAVO",
        code: "HAVO"
    },
    {
        name: "VWO",
        code: "VWO"
    },
    {
        name: "VMBO TL/GL",
        code: "VMBO-TL-GL"
    },
    {
        name: "VMBO KB",
        code: "VMBO-KB"
    },
    {
        name: "VMBO BB",
        code: "VMBO-BB"
    }
];
const HeaderLinks = [
    {
        title: "Home",
        link: "/"
    },
    {
        title: "Over ons",
        link: "/Overons"
    },
    {
        title: "FAQ",
        link: "/faq"
    },
    {
        title: "Contact",
        link: "/contact"
    }
];
// ── Feedback flow ───────────────────────────────────────────────
/**
 * Audience of a feedback submission. Students and teachers share the
 * same `feedback` Firestore collection but get a distinct per-year flag
 * on their user doc so the popup / sidebar banner / email campaign can
 * be gated per audience without crosstalk.
 */ const FEEDBACK_AUDIENCES = {
    STUDENT: "student",
    TEACHER: "teacher"
};
/**
 * Field name on the user doc that gates the per-year feedback prompt.
 * The legacy field `feedbackGiven` (no year) stays read-only.
 *
 * For backwards compatibility the student flag keeps its original
 * `feedbackGiven_<year>` shape; the teacher flag uses a distinct
 * `teacherFeedbackGiven_<year>` namespace.
 */ const FEEDBACK_FLAG_KEY = function(year) {
    let audience = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : FEEDBACK_AUDIENCES.STUDENT;
    return audience === FEEDBACK_AUDIENCES.TEACHER ? "teacherFeedbackGiven_".concat(year) : "feedbackGiven_".concat(year);
};
/**
 * Funnel events emitted by the feedback flow. See
 * docs/feedback-schema.md for the full meaning of each event.
 */ const FEEDBACK_TELEMETRY_EVENTS = {
    POPUP_SHOWN: "POPUP_SHOWN",
    POPUP_DISMISSED: "POPUP_DISMISSED",
    POPUP_CLICKED: "POPUP_CLICKED",
    FORM_OPENED: "FORM_OPENED",
    QUESTION_ANSWERED: "QUESTION_ANSWERED",
    FORM_ABANDONED: "FORM_ABANDONED",
    FORM_SUBMITTED: "FORM_SUBMITTED",
    NOTIFICATION_SHOWN: "NOTIFICATION_SHOWN",
    NOTIFICATION_CLICKED: "NOTIFICATION_CLICKED",
    BANNER_SHOWN: "BANNER_SHOWN",
    BANNER_CLICKED: "BANNER_CLICKED",
    BANNER_DISMISSED: "BANNER_DISMISSED",
    POST_ATTEMPT_SHOWN: "POST_ATTEMPT_SHOWN",
    POST_ATTEMPT_CLICKED: "POST_ATTEMPT_CLICKED"
};
/**
 * How a user reached the feedback form. Persisted on the submission
 * doc (`feedback/{id}.source`) and on every telemetry event.
 */ const FEEDBACK_TRIGGER_SOURCES = {
    POPUP: "POPUP",
    NOTIFICATION: "NOTIFICATION",
    DIRECT_NAV: "DIRECT_NAV",
    POST_ATTEMPT: "POST_ATTEMPT",
    EMAIL_CAMPAIGN: "EMAIL_CAMPAIGN",
    BANNER: "BANNER"
};
const sectionData = [
    {
        image: __webpack_require__(27736),
        subtitle: "Bron: Het Parool",
        heading: "Kansen(on)gelijkheid",
        description1: "Op de middelbare school zijn er activiteiten die niet voor iedereen weggelegd is. Zonder er bij stil te staan kennen wij het allemaal wel. Denk aan leerlingen die schoolfoto's \xfcberhaupt niet aannemen of leerlingen diehelaas niet mee kunnen op een buitenlandse excursie. Maar er is meer. Experts vrezen voor toename van ongelijkheid.",
        description2: "Mede door de populariteit van peperdure examentrainingen. Zo is het momenteel gebruikelijk dat leerlingen na hun schoolexamen een externe training volgen. Hier zit een drempel voor een grote groep leerlingen wiens ouders de kosten niet kunnen ophoesten. Alle leerlingen verdienen dezelfde kans om zich goed voor te bereiden op het eindexamen."
    },
    {
        image: __webpack_require__(6285),
        heading: "CET voor iedereen",
        description1: "CETrainer is een platform die gratis moet zijn voor alle leerlingen. Wij hanteren een kostprijs waar schoolbesturen niet omheen kunnen. Hiermee worden de kosten voor onze examentraining nooit doorgerekend aan de ouders van de scholieren. De vraag naar examentrainingen is enorm gestegen, helemaal sinds de Corona pandemie. ",
        description2: "Steeds meer leerlingen kijken graag online instructies en steeds meer docenten maken gebruik van videomateriaal in de lessen ter instructie. Daarnaast behoort het gebruik van online leermiddelen steeds meer tot het basispakket van leerlingen. De krantenkoppen spreken boekdelen."
    }
];
// Layouts the CMS exam section editor can switch between, remembered per
// browser under SECTION_EDITOR_LAYOUT_KEY (hooks/useSectionEditorLayout.ts).
const SECTION_EDITOR_LAYOUTS = [
    "section",
    "focus",
    "split",
    "tabs"
];
const SECTION_EDITOR_LAYOUT_KEY = "cmsSectionEditorLayout";
// Narrowest window the split layout fits in. Mirrors the SASS $xl-up
// breakpoint (stylesheets/abstracts/_variables.sass: $xl: 1200px); change both
// together.
const SECTION_EDITOR_SPLIT_MIN_WIDTH = 1200;
// With the PDF panel open, Split puts question and answers side by side only
// while the sections tab's main column (content box) is at least this wide.
// Today's narrowest Split - a 1200px window, the 248px app sidebar, the 56px
// rail - leaves that column about 839px; a little slack keeps the same floor.
const SECTION_EDITOR_SPLIT_MIN_EDITOR_WIDTH = 820;
// With the PDF panel open, the exam editor's Jump to rail starts collapsed
// unless the Sections tab is at least this wide: the 260px rail, the 24px
// gutter and SECTION_EDITOR_SPLIT_MIN_EDITOR_WIDTH for the editor.
const EXAM_EDITOR_RAIL_ROOM_WIDTH = 260 + 24 + 820;
// The exam editor's PDF panel (components/CMS/Exam/Editor/PdfPanel) docks
// beside the editor from the SASS $laptop-up breakpoint ($laptop: 1023px).
const EXAM_PDF_PANEL_DOCK_QUERY = "(min-width: 1023px)";
// The docked PDF panel's width, as a share of the editor workspace, chosen
// with the drag handle and remembered per browser under
// EXAM_PDF_PANEL_RATIO_KEY (hooks/useExamPdfPanelWidth.ts). It never goes
// below the minimum width, nor above the maximum share or what would leave
// the editor column less than EXAM_EDITOR_MIN_WIDTH.
const EXAM_PDF_PANEL_RATIO_KEY = "cmsPdfPanelRatio";
const EXAM_PDF_PANEL_DEFAULT_RATIO = 0.4;
const EXAM_PDF_PANEL_MAX_RATIO = 0.6;
const EXAM_PDF_PANEL_MIN_WIDTH = 420;
const EXAM_EDITOR_MIN_WIDTH = 640;
// The handle's column between editor and panel: ExamEditor's --pdf-gap.
const EXAM_PDF_PANEL_GAP = 20;
// Id of the element that holds the PDF panel; toggles point at it.
const EXAM_PDF_PANEL_ID = "exam-pdf-panel";
// Per-exam panel state in localStorage:
// `cmsPdfPanel:{level}:{subject}:{examId}` -> { open, tab, pages }.
const EXAM_PDF_PANEL_KEY_PREFIX = "cmsPdfPanel";
// CMS comments (docs/features/cms-comments.md): staff comments on an exam or
// one of its questions, in the top-level `cmsComments` collection.
const CMS_COMMENTS_COLLECTION = "cmsComments";
// Longest comment body, counted after trimming.
const CMS_COMMENT_MAX_LENGTH = 2000;
// E2E comments start with this prefix. Only these, written by an account in
// CMS_COMMENT_TEST_AUTHORS, get `testData: true` and may be cleaned up by
// scripts/cleanup-cms-comments-test-data.ts.
const CMS_COMMENT_TEST_PREFIX = "[TEST]";
// The QA trainer account the CMS comments E2E spec signs in as.
const CMS_COMMENT_TEST_AUTHORS = [
    "demo-trainer@cetrainer.nl"
];
// DOM id of the comments drawer (one per page); the Comments button points
// at it with aria-controls.
const CMS_COMMENTS_DRAWER_ID = "cms-comments-drawer";
// React Query key of the dashboard's open-comment counts per exam.
const CMS_COMMENT_OPEN_COUNTS_KEY = [
    "cms-comment-open-counts"
];
// Copy to CMS with images (docs/features/exam-auto-images-4a.md, D4): fill
// section-text (tekstboekje) images from the image library. On since the
// validator's assets-0.6.0 section fill and `section_key` (2026-10-06).
// Hooks pass it to the planner; false restores the 4a "add by hand" path.
const SECTION_TEXT_AUTO_FILL_ENABLED = true;
// Exam review (docs/features/exam-auto-images-4b.md §5.3): review writes need
// examAssets.extractorVersion === extraction.assets.extractor_version, both at
// least this version (the library check).
const REVIEW_MIN_EXTRACTOR_VERSION = "assets-0.6.0";
// How often a failed `usedIn` write on an examAssets item is retried after
// the CMS write succeeded (backoff 500 ms, then 1500 ms).
const COPY_USED_IN_RETRIES = 2;


/***/ }),

/***/ 19227:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__Oyv5C","input__title":"Input_input__title__I4PSv","input__element":"Input_input__element__2XJOk","error":"Input_error__103be","required":"Input_required__ASifv"};

/***/ }),

/***/ 40500:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contact":"ContactButton_contact__sCDsU","contact__visible":"ContactButton_contact__visible__k_4x9","dialog":"ContactButton_dialog__bGlap","dialog__icon":"ContactButton_dialog__icon__BWzWB","dialog__link":"ContactButton_dialog__link__xDyoH","dialog__option__label":"ContactButton_dialog__option__label__kr73U","form__contact":"ContactButton_form__contact__kxk2Z","form__call":"ContactButton_form__call__SdE3g","form__contact__buttons":"ContactButton_form__contact__buttons__2KTn8","form__call__buttons":"ContactButton_form__call__buttons__WuTZ_"};

/***/ })

}]);